import gql from 'graphql-tag'

export default gql`
  query getWorkExperiences($id: String!) {
    getExpert(id: $id) {
      id
      workExperiences {
        id
        description
        employer
        endDate
        financialTags
        industryTags
        isCurrentEmployer
        softwareTags
        startDate
        title
      }

      onboardingStep
    }
  }
`
